import * as React from 'react';
import { ElearningPrompt } from './prompts/ElearningPrompt';
import { GridContainer } from '@pec/aion-ui-components/components/GridContainer';
import { Paper } from '@pec/aion-ui-components/components/Paper';
import { RegisterPrompt } from './prompts/RegisterPrompt';

type Props = {
  isRegistered: boolean;
};

export const UserPrompt: React.FC<Props> = ({ isRegistered }) => (
  <Paper mainContainer>
    <GridContainer style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
      {isRegistered ? <ElearningPrompt /> : <RegisterPrompt />}
    </GridContainer>
  </Paper>
);
